import React, {Component} from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/Footer.css'


export default class Footer extends Component{


     
    
    
    render(){
        return(
            <>
                <div className="footer">
                    <p className="Deploy">Deployed Using Github Pages! Made With React!</p>
                    
                </div>
           </>
        )
    }
}